import {
    REWARD_INFO,
    SOCIAL_IDS,
    VALIDITY_DATA
    // PINCODE_DATA,
    // DEVICE_DATA
} from "../action-types/state-update";

const initialState = {
    // cart_count: 0,
    social_ids: [],
    // pincode_data: null,
    // device_data: {is_initial: 1, device_id: ''}//{device_id: ''}
    // validity_data: {port: -1, ss: -1}
    validity_data: null,
    // reward_info: {total_badges: '',
    //               total_points: '',level: ''}
    reward_info: null
}

const ReducerStateUpdate = (state = initialState, { type, payload }) => {
    switch (type) {
      // case CART_COUNT:
      //   return {
      //     ...state,
      //     cart_count: payload
      //   };
      case SOCIAL_IDS:
        return {
          ...state,
          social_ids: JSON.stringify(payload)
        };
      case VALIDITY_DATA:
        return {
          ...state,
          validity_data: JSON.stringify(payload)
        };
      case REWARD_INFO:
        if(payload){
          return {
            ...state,
            reward_info: payload ? JSON.stringify(payload) : null
          };
        }else{
          return initialState; 
        }
      // case PINCODE_DATA:
      //   return {
      //     ...state,
      //     pincode_data: JSON.stringify(payload)
      //   };
      // case DEVICE_DATA:
      //   return {
      //     ...state,
      //     device_data: JSON.stringify(payload)
      //   };
      default:
        return state;
    }
  };

export default ReducerStateUpdate;